module.exports = __webpack_public_path__ + "img/flare.d8bdf4d3.png";